module.exports = __webpack_public_path__ + "img/full_star.dcaa2fa8.svg";